'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTabsContext } from './tabs.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const propTypes = {
    /**
   * The id of the matching tab
   */ tabId: PropTypes.string.isRequired
};
const propKeysToRemove = [
    'tabId'
];
/**
 * @subcomponent Tabs
 */ const TabHeaderInput = renderWithRef('TabHeaderInput', propTypes, (props, ref)=>{
    const { tabsName, selectedTabId, contentIds, registerHeader, unregisterHeader, onRequestTabChange } = useTabsContext();
    const { children, id: customId, tabId } = props;
    const id = useId(customId);
    React.useEffect(()=>{
        registerHeader(tabId, id);
        return ()=>unregisterHeader(tabId);
    }, [
        tabId,
        id,
        registerHeader,
        unregisterHeader
    ]);
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "input",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        props: _object_spread_props(_object_spread({}, props), {
            id: id,
            type: 'radio',
            role: 'tab',
            name: tabsName,
            ['aria-controls']: contentIds[tabId],
            checked: tabId === selectedTabId,
            onChange: (event)=>{
                if (event.target.checked) {
                    onRequestTabChange(tabId, event);
                }
            }
        })
    }, children);
});

export { TabHeaderInput };
